// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"279":"0ee2b1ed","945":"0ee2b1ed"}[chunkId] + ".chunk.css";
};